// Instrument Comprehension Questions for AFOQT
// Auto-generated - matches instrument panels to aircraft views
import { IMAGE_PATH } from '../config';

export const instrumentCompData = [
  {
    "id": 27,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0027.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0027.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0150.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0131.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 38,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0038.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0031.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0156.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0038.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0027.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 86,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0086.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0086.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0098.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0183.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0142.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 144,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0144.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0144.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0002.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0099.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0072.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 128,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0128.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0095.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0191.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0128.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0112.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 195,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0195.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0195.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0098.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0039.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0139.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 123,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0123.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0082.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0123.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0002.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 11,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0011.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0003.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0083.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0039.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0011.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 32,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0032.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0092.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0032.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0049.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0040.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 28,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0028.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0037.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0059.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0028.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0004.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 140,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0140.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0099.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0140.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0103.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0072.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 92,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0092.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0063.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0093.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0092.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 104,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0104.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0100.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0060.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0002.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0104.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 15,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0015.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0086.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0015.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0026.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 48,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0048.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0048.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0068.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0079.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0037.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 89,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0089.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0089.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0056.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0173.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 124,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0124.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0124.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0060.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0172.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0080.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 53,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0053.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0049.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0053.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0066.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0094.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 111,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0111.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0134.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0059.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0111.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0192.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 108,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0108.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0077.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0108.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0018.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0058.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 115,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0115.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0115.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0197.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0010.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0067.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 70,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0070.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0165.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0123.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0070.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0054.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 113,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0113.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0091.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0030.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0081.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0113.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 130,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0130.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0130.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0153.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0024.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0186.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 145,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0145.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0145.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0140.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0168.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0087.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 94,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0094.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0073.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0094.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0039.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0129.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 107,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0107.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0107.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0087.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0175.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0002.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 59,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0059.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0059.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0025.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0064.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0069.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 173,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0173.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0190.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0173.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0178.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 36,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0036.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0066.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0043.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0175.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0036.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 42,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0042.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0042.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0048.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0037.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0137.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 30,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0030.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0066.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0030.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0071.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0002.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 4,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0004.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0004.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0078.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0003.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0080.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 189,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0189.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0034.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0189.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0092.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0102.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 122,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0122.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0108.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0122.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0167.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 185,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0185.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0057.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0037.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0088.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0185.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 134,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0134.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0104.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0134.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0002.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0152.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 199,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0199.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0021.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0199.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0006.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0061.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 75,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0075.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0196.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0035.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0075.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 135,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0135.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0073.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0135.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0019.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0100.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 164,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0164.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0024.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0164.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0192.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0154.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 125,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0125.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0153.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0030.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0008.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0125.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 184,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0184.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0184.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0189.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0042.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0073.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 74,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0074.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0087.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0074.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0091.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0015.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 85,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0085.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0011.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0039.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0001.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0085.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 119,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0119.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0087.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0058.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0079.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0119.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 26,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0026.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0099.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0083.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0026.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0067.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 65,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0065.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0065.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0088.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0077.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 141,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0141.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0078.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0141.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0060.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0155.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 69,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0069.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0003.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0069.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0036.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 97,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0097.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0043.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0097.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0006.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0080.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 1,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0001.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0095.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0157.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0001.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0084.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 8,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0008.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0081.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0090.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0110.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0008.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 116,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0116.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0090.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0045.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0042.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0116.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 29,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0029.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0042.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0174.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0075.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0029.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 68,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0068.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0098.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0068.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0076.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0078.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 41,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0041.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0041.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0148.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 198,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0198.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0198.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0034.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0099.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0141.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 40,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0040.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0085.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0040.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0071.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0143.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 176,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0176.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0082.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0058.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0176.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0083.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 76,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0076.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0187.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0076.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0082.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0092.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 110,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0110.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0110.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0102.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0015.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0024.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 136,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0136.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0055.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0066.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0166.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0136.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 96,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0096.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0100.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0001.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0091.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0096.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 132,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0132.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0044.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0184.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0132.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0012.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 106,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0106.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0106.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0193.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0022.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0004.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 45,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0045.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0090.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0045.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0028.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0057.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 171,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0171.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0198.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0079.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0171.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0088.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 14,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0014.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0098.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0025.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0081.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0014.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 83,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0083.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0060.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0083.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0049.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0054.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 61,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0061.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0185.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0131.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0061.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 190,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0190.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0035.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0139.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0190.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0028.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 82,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0082.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0114.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0123.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0143.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0082.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 153,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0153.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0055.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0053.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0058.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0153.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 87,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0087.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0087.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0040.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0077.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0098.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 100,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0100.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0064.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0123.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0048.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0100.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 149,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0149.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0094.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0149.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0020.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0186.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 81,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0081.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0027.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0139.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0098.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0081.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 167,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0167.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0167.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0050.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0169.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0089.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 166,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0166.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0166.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0064.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0013.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0096.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 49,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0049.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0049.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0050.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0031.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0074.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 197,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0197.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0083.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0036.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0020.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0197.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 105,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0105.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0023.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0046.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0042.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0105.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 101,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0101.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0101.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0066.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0082.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 52,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0052.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0052.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0007.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0152.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0037.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 57,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0057.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0098.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0057.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0093.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 6,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0006.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0006.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0030.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0039.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0022.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 152,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0152.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0080.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0152.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0144.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 180,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0180.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0061.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0180.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0055.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0118.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 150,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0150.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0031.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0069.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0175.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0150.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 120,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0120.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0006.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0090.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0144.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0120.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 77,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0077.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0073.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0077.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0037.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0059.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 139,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0139.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0181.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0139.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0128.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0031.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 181,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0181.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0190.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0181.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0091.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0040.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 25,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0025.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0025.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0022.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0036.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0198.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 80,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0080.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0080.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0117.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0091.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 194,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0194.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0194.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0099.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0094.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0009.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 168,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0168.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0034.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0063.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0168.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0009.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 84,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0084.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0080.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0084.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0036.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0186.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 121,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0121.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0043.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0121.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0004.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0087.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 12,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0012.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0031.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0012.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0007.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0087.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 98,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0098.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0110.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0096.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0046.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0098.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 5,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0005.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0005.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0060.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0172.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 196,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0196.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0137.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0087.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0084.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0196.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 159,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0159.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0094.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0159.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0173.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0049.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 66,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0066.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0066.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0053.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0193.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0085.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 47,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0047.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0065.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0047.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0044.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 174,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0174.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0174.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0090.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0092.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 10,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0010.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0133.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0185.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0008.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0010.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 117,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0117.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0117.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0027.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0099.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 44,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0044.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0105.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0068.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0141.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0044.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 72,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0072.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0077.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0019.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0072.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 91,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0091.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0057.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0091.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0004.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0080.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 51,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0051.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0087.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0067.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0051.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0031.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 34,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0034.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0034.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0128.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0119.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0062.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 103,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0103.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0090.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0103.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0086.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0162.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 154,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0154.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0154.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0193.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0047.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 162,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0162.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0162.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0089.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0081.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0168.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 58,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0058.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0026.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0058.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0072.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0099.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 43,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0043.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0004.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0075.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0119.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0043.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 7,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0007.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0063.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0088.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0187.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0007.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 109,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0109.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0109.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0059.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0042.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0010.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 179,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0179.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0073.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0184.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0179.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0169.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 62,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0062.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0049.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0062.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0167.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0068.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 156,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0156.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0030.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0156.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0031.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0076.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 90,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0090.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0042.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0090.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0085.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 200,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0200.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0051.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0055.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0011.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0200.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 138,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0138.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0027.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0071.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0017.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0138.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 182,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0182.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0182.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0145.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0054.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0004.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 20,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0020.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0139.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0173.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0146.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 78,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0078.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0190.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0054.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0078.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0073.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 127,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0127.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0014.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0082.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0127.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0026.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 183,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0183.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0009.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0183.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0032.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 143,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0143.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0090.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0014.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0143.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 88,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0088.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0088.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0024.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0034.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0125.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 129,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0129.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0026.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0129.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0009.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 142,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0142.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0021.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0142.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0021.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 137,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0137.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0044.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0072.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0137.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0003.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 16,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0016.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0021.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0081.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0134.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0016.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 163,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0163.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0163.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0033.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0119.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0155.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 31,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0031.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0049.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0011.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0025.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0031.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 191,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0191.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0014.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0094.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0191.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 177,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0177.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0177.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0004.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0062.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0112.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 165,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0165.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0165.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0093.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0040.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0014.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 148,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0148.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0148.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0013.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0075.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0020.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 24,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0024.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0006.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0179.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0024.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 186,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0186.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0140.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0135.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0186.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0109.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 192,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0192.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0192.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0022.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0031.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0153.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 161,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0161.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0084.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0107.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0161.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 95,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0095.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0095.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0094.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0124.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0059.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 112,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0112.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0091.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0014.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0186.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0112.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 60,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0060.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0068.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0069.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0147.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0060.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 187,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0187.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0075.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0187.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0007.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 151,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0151.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0091.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0066.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0132.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0151.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 17,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0017.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0052.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0032.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0017.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0128.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 146,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0146.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0146.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0096.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0028.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 79,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0079.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0057.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0025.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0079.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0091.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 64,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0064.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0064.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0197.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0082.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0183.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 73,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0073.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0073.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0004.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0061.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0089.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 3,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0003.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0079.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0030.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0004.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0003.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 71,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0071.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0020.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0071.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0094.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0049.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 188,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0188.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0042.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0188.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0153.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0076.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 133,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0133.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0047.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0133.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0147.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0088.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 46,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0046.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0046.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0076.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0031.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0149.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 157,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0157.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0154.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0122.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0157.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0120.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 50,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0050.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0058.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0036.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0050.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0086.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 18,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0018.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0036.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0018.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0182.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0093.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 9,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0009.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0009.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0009.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0124.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0165.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 169,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0169.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0169.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0097.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0005.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0095.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 131,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0131.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0160.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0131.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0166.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0138.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 19,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0019.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0153.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0185.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0019.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0087.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 175,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0175.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0008.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0002.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0033.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0175.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 99,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0099.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0099.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0038.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0128.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0107.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 114,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0114.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0070.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0114.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0012.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0013.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 35,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0035.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0052.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0049.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0007.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0035.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 155,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0155.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0010.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0071.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0155.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0082.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 37,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0037.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0037.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0071.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0025.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0066.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 147,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0147.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0083.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0096.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0147.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0011.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 93,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0093.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0093.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0011.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0058.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0002.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 158,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0158.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0096.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0134.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0158.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 126,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0126.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0049.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0126.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0015.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0055.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 172,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0172.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0005.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0022.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0172.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0051.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 193,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0193.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0030.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0129.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0096.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0193.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 33,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0033.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0083.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0087.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0085.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0033.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 55,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0055.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0144.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0055.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0193.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0029.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 178,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0178.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0178.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0057.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0170.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0056.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 13,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0013.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0130.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0078.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0121.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0013.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 160,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0160.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0038.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0053.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0073.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0160.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 67,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0067.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0067.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0051.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0029.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0085.webp`
    ],
    "correct": 0,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 2,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0002.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0007.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0002.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0050.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0072.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 39,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0039.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0100.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0093.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0039.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 56,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0056.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0047.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0137.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0056.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0179.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 118,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0118.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0006.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0118.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0024.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 23,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0023.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0085.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0067.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0065.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0023.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 170,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0170.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0072.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0170.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0008.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0097.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 102,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0102.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0077.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0026.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0023.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0102.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 22,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0022.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0044.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0056.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0171.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0022.webp`
    ],
    "correct": 3,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 54,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0054.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0061.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0054.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0051.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0066.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 21,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0021.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0077.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0010.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0021.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0093.webp`
    ],
    "correct": 2,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  },
  {
    "id": 63,
    "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0063.webp`,
    "question": "Which aircraft view matches the instrument readings shown above?",
    "options": [
      `${IMAGE_PATH}/instruments/instcomp_Plane-0079.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0063.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-0041.webp`,
      `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0040.webp`
    ],
    "correct": 1,
    "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
  }
];



// export const instrumentCompData = [
//   {
//     "id": 1,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0001.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0095.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0157.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0001.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0084.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 2,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0002.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0007.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0002.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0050.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0072.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 3,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0003.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0079.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0030.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0004.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0003.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 4,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0004.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0004.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0078.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0003.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0080.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 5,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0005.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0005.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0060.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0172.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 6,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0006.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0006.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0030.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0039.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0022.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 7,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0007.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0063.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0088.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0187.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0007.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 8,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0008.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0081.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0090.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0110.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0008.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 9,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0009.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0009.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0009.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0124.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0165.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 10,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0010.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0133.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0185.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0008.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0010.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 11,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0011.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0003.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0083.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0039.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0011.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 12,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0012.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0031.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0012.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0007.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0087.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 13,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0013.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0130.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0078.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0121.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0013.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 14,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0014.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0098.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0025.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0081.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0014.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 15,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0015.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0086.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0015.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0026.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 16,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0016.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0021.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0081.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0134.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0016.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 17,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0017.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0052.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0032.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0017.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0128.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 18,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0018.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0036.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0018.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0182.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0093.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 19,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0019.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0153.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0185.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0019.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0087.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 20,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0020.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0139.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0173.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0146.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 21,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0021.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0077.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0010.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0021.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0093.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 22,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0022.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0044.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0056.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0171.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0022.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 23,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0023.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0085.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0067.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0065.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0023.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 24,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0024.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0006.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0179.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0024.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 25,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0025.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0025.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0022.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0036.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0198.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 26,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0026.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0099.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0083.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0026.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0067.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 27,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0027.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0027.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0150.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0131.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 28,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0028.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0037.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0059.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0028.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0004.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 29,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0029.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0042.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0174.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0075.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0029.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 30,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0030.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0066.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0030.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0071.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0002.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 31,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0031.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0049.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0011.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0025.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0031.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 32,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0032.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0092.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0032.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0049.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0040.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 33,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0033.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0083.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0087.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0085.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0033.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 34,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0034.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0034.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0128.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0119.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0062.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 35,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0035.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0052.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0049.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0007.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0035.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 36,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0036.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0066.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0043.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0175.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0036.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 37,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0037.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0037.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0071.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0025.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0066.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 38,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0038.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0031.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0156.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0038.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0027.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 39,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0039.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0100.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0093.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0039.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 40,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0040.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0085.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0040.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0071.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0143.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 41,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0041.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0041.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0148.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 42,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0042.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0042.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0048.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0037.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0137.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 43,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0043.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0004.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0075.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0119.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0043.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 44,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0044.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0105.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0068.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0141.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0044.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 45,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0045.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0090.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0045.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0028.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0057.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 46,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0046.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0046.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0076.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0031.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0149.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 47,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0047.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0065.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0047.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0044.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 48,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0048.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0048.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0068.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0079.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0037.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 49,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0049.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0049.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0050.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0031.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0074.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 50,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0050.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0058.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0036.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0050.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0086.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 51,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0051.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0087.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0067.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0051.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0031.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 52,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0052.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0052.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0007.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0152.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0037.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 53,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0053.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0049.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0053.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0066.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0094.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 54,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0054.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0061.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0054.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0051.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0066.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 55,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0055.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0144.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0055.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0193.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0029.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 56,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0056.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0047.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0137.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0056.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0179.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 57,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0057.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0098.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0057.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0093.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 58,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0058.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0026.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0058.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0072.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0099.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 59,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0059.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0059.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0025.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0064.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0069.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 60,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0060.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0068.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0069.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0147.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0060.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 61,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0061.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0185.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0131.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0061.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 62,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0062.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0049.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0062.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0167.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0068.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 63,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0063.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0079.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0063.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0041.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0040.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 64,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0064.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0064.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0197.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0082.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0183.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 65,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0065.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0065.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0088.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0077.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 66,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0066.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0066.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0053.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0193.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0085.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 67,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0067.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0067.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0051.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0029.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0085.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 68,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0068.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0098.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0068.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0076.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0078.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 69,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0069.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0003.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0069.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0036.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 70,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0070.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0165.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0123.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0070.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0054.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 71,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0071.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0020.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0071.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0094.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0049.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 72,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0072.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0077.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0019.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0072.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 73,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0073.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0073.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0004.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0061.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0089.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 74,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0074.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0087.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0074.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0091.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0015.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 75,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0075.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0196.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0035.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0075.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 76,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0076.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0187.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0076.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0082.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0092.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 77,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0077.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0073.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0077.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0037.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0059.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 78,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0078.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0190.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0054.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0078.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0073.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 79,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0079.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0057.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0025.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0079.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0091.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 80,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0080.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0080.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0117.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0091.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 81,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0081.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0027.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0139.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0098.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0081.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 82,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0082.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0114.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0123.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0143.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0082.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 83,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0083.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0060.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0083.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0049.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0054.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 84,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0084.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0080.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0084.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0036.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0186.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 85,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0085.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0011.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0039.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0001.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0085.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 86,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0086.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0086.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0098.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0183.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0142.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 87,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0087.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0087.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0040.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0077.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0098.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 88,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0088.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0088.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0024.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0034.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0125.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 89,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0089.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0089.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0056.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0173.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 90,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0090.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0042.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0090.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0085.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 91,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0091.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0057.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0091.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0004.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0080.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 92,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0092.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0063.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0093.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0092.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 93,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0093.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0093.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0011.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0058.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0002.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 94,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0094.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0073.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0094.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0039.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0129.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 95,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0095.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0095.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0094.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0124.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0059.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 96,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0096.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0100.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0001.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0091.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0096.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 97,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0097.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0043.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0097.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0006.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0080.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 98,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0098.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0110.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0096.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0046.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0098.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 99,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0099.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0099.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0038.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0128.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0107.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 100,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0100.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0064.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0123.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0048.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0100.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 101,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0101.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0101.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0066.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0082.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 102,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0102.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0077.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0026.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0023.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0102.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 103,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0103.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0090.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0103.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0086.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0162.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 104,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0104.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0100.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0060.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0002.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0104.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 105,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0105.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0023.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0046.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0042.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0105.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 106,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0106.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0106.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0193.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0022.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0004.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 107,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0107.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0107.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0087.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0175.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0002.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 108,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0108.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0077.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0108.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0018.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0058.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 109,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0109.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0109.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0059.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0042.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0010.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 110,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0110.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0110.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0102.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0015.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0024.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 111,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0111.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0134.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0059.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0111.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0192.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 112,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0112.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0091.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0014.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0186.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0112.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 113,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0113.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0091.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0030.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0081.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0113.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 114,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0114.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0070.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0114.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0012.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0013.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 115,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0115.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0115.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0197.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0010.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0067.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 116,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0116.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0090.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0045.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0042.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0116.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 117,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0117.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0117.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0027.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0099.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 118,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0118.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0006.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0118.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0024.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 119,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0119.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0087.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0058.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0079.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0119.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 120,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0120.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0006.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0090.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0144.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0120.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 121,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0121.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0043.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0121.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0004.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0087.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 122,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0122.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0108.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0122.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0167.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 123,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0123.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0082.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0123.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0002.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 124,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0124.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0124.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0060.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0172.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0080.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 125,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0125.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0153.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0030.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0008.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0125.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 126,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0126.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0049.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0126.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0015.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0055.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 127,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0127.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0014.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0082.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0127.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0026.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 128,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0128.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0095.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0191.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0128.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0112.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 129,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0129.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0026.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0129.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0009.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 130,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0130.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0130.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0153.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0024.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0186.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 131,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0131.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0160.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0131.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0166.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0138.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 132,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0132.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0044.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0184.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0132.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0012.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 133,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0133.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0047.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0133.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0147.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0088.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 134,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0134.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0104.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0134.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0002.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0152.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 135,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0135.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0073.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0135.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0019.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0100.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 136,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0136.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0055.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0066.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0166.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0136.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 137,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0137.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0044.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0072.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0137.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0003.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 138,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0138.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0027.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0071.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0017.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0138.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 139,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0139.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0181.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0139.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0128.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0031.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 140,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0140.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0099.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0140.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0103.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0072.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 141,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0141.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0078.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0141.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0060.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0155.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 142,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0142.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0021.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0142.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0021.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 143,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0143.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0090.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0014.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0143.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 144,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0144.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0144.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0002.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0099.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0072.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 145,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0145.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0145.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0140.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0168.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0087.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 146,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0146.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0146.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0096.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0028.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 147,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0147.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0083.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0096.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0147.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0011.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 148,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0148.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0148.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0013.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0075.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0020.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 149,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0149.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0094.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0149.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0020.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0186.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 150,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0150.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0031.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0069.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0175.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0150.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 151,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0151.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0091.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0066.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0132.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0151.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 152,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0152.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0080.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0152.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0020.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0144.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 153,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0153.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0055.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0053.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0058.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0153.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 154,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0154.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0154.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0193.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0047.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 155,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0155.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0010.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0071.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0155.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0082.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 156,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0156.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0030.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0156.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0031.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0076.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 157,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0157.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0154.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0122.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0157.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0120.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 158,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0158.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0096.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0134.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0158.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 159,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0159.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0094.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0159.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0173.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0049.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 160,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0160.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0038.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0053.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0073.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0160.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 161,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0161.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0084.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0107.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0161.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 162,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0162.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0162.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0089.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0081.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0168.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 163,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0163.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0163.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0033.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0119.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0155.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 164,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0164.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0024.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0164.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0192.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0154.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 165,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0165.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0165.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0093.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0040.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0014.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 166,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0166.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0166.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0064.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0013.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0096.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 167,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0167.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0167.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0050.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0169.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0089.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 168,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0168.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0034.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0063.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0168.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0009.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 169,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0169.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0169.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0097.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0005.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0095.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 170,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0170.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0072.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0170.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0008.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0097.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 171,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0171.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0198.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0079.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0171.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0088.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 172,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0172.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0005.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0022.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0172.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0051.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 173,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0173.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0190.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0173.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0070.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0178.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 174,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0174.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0174.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0090.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0092.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 175,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0175.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0008.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0002.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0033.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0175.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 176,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0176.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0082.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0058.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0176.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0083.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 177,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0177.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0177.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0004.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0062.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0112.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 178,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0178.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0178.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0057.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0170.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0056.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 179,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0179.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0073.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0184.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0179.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0169.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 180,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0180.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0061.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0180.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0055.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0118.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 181,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0181.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0190.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0181.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0091.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0040.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 182,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0182.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0182.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0145.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0054.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0004.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 183,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0183.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0009.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0041.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0183.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0032.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 184,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0184.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0184.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0189.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0042.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0073.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 185,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0185.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0057.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0037.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0088.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0185.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 186,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0186.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0140.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0135.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0186.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0109.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 187,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0187.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0029.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0075.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0187.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0007.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 188,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0188.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0042.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0188.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0153.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0076.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 189,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0189.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0034.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0189.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0092.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0102.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 190,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0190.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0035.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0139.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0190.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0028.webp`
//     ],
//     "correct": 2,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 191,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0191.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0014.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0094.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0023.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0191.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 192,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0192.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0192.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0022.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0031.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0153.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 193,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0193.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0030.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0129.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0096.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0193.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 194,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0194.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0194.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0099.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0094.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0009.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 195,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0195.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0195.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0098.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0039.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0139.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 196,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0196.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0137.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0087.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0084.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0196.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 197,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0197.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0083.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0036.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0020.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0197.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 198,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0198.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0198.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0034.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0099.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0141.webp`
//     ],
//     "correct": 0,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 199,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0199.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0021.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0199.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0006.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0061.webp`
//     ],
//     "correct": 1,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   },
//   {
//     "id": 200,
//     "instrumentImage": `${IMAGE_PATH}/instruments/instcomp_Insts-0200.webp`,
//     "question": "Which aircraft view matches the instrument readings shown above?",
//     "options": [
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0051.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0055.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-MIRROR-0011.webp`,
//       `${IMAGE_PATH}/instruments/instcomp_Plane-0200.webp`
//     ],
//     "correct": 3,
//     "explanation": "The attitude and heading indicators show a specific aircraft orientation. Match the pitch, bank angle, and heading to the correct aircraft view."
//   }
// ];

// ... your existing data above ...

export const INSTRUMENT_COMP_CONFIG = {
  sectionName: "Instrument Comprehension",
  totalQuestions: 200,
  timeLimit: 5,
  instructions: "Study the attitude indicator and heading indicator. Then select the aircraft view that best matches the instrument readings. Pay attention to pitch (nose up/down), bank (wings tilted), and heading direction."
};

// const shuffleArray = (array) => {
//   const shuffled = [...array];
//   for (let i = shuffled.length - 1; i > 0; i--) {
//     const j = Math.floor(Math.random() * (i + 1));
//     [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
//   }
//   return shuffled;
// };

// // Custom stringify that preserves IMAGE_PATH template literals
// const shuffledData = shuffleArray(instrumentCompData);
// const output = shuffledData.map(item => {
//   return `  {
//     "id": ${item.id},
//     "instrumentImage": \`\${IMAGE_PATH}/instruments/instcomp_Insts-${String(item.id).padStart(4, '0')}.webp\`,
//     "question": "${item.question}",
//     "options": [
//       \`\${IMAGE_PATH}/instruments/${item.options[0].split('/instruments/')[1].replace('/afoqt-mock-exam/images/', '')}\`,
//       \`\${IMAGE_PATH}/instruments/${item.options[1].split('/instruments/')[1].replace('/afoqt-mock-exam/images/', '')}\`,
//       \`\${IMAGE_PATH}/instruments/${item.options[2].split('/instruments/')[1].replace('/afoqt-mock-exam/images/', '')}\`,
//       \`\${IMAGE_PATH}/instruments/${item.options[3].split('/instruments/')[1].replace('/afoqt-mock-exam/images/', '')}\`
//     ],
//     "correct": ${item.correct},
//     "explanation": "${item.explanation}"
//   }`;
// }).join(',\n');

// console.log('export const instrumentCompData = [\n' + output + '\n];');
// // TEMPORARILY export the shuffled version instead
// export default shuffledData;
